<template>
  <div class="home">
    <enter-screen @enter="onEnter" v-if="!entered && newFormCreated" />
    <call-form v-else />
  </div>
</template>

<script>
import CallForm  from '@/components/CallForm.vue'
import EnterScreen  from '@/components/EnterScreen.vue'

export default {
  name: 'Home',
  data: () => ({
    entered: false
  }),
  components: {
    CallForm,
    EnterScreen
  },
  computed: {
    newFormCreated() {
      console.log(this.$route?.hash)
      if (this.$route?.hash?.startsWith('#problems')) {
        return false
      }
      return this.$route?.query?.id === undefined && !this.$store.getters.formAlreadyLoaded
    },

  },
  methods: {
    onEnter() {
      this.entered = true
    },

  }
}
</script>
